import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'js-cookie'
import { BRAND } from '../constants/brand'

Vue.use(Vuex)

// 安全解析 localStorage 中的 JSON，防止 "undefined" 等非法 JSON 导致崩溃
function safeParse(str) {
  if (!str || str === 'undefined' || str === 'null') return null
  try {
    return JSON.parse(str)
  } catch (e) {
    console.warn('[store] localStorage 数据解析失败，已重置:', e.message)
    localStorage.removeItem('wms-user')
    return null
  }
}

function safeParseBranding(str) {
  if (!str || str === 'undefined' || str === 'null') return null
  try {
    return JSON.parse(str)
  } catch (e) {
    localStorage.removeItem('wms-branding')
    return null
  }
}

const DEFAULT_BRANDING = {
  companyName: '灵犀资产 · FAMS 平台',
  shortName: 'FAMS',
  contactPhone: '',
  systemName: BRAND.name
}

function readInitialAuth() {
  const token = Cookie.get('wms-token') || ''
  if (!token) {
    localStorage.removeItem('wms-user')
    return { token: '', userInfo: null }
  }
  const parts = token.split('.')
  if (parts.length < 2) {
    Cookie.remove('wms-token')
    localStorage.removeItem('wms-user')
    return { token: '', userInfo: null }
  }
  try {
    const json = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = json + '==='.slice((json.length + 3) % 4)
    const payload = JSON.parse(atob(padded))
    if (payload.exp && payload.exp * 1000 <= Date.now()) {
      Cookie.remove('wms-token')
      localStorage.removeItem('wms-user')
      return { token: '', userInfo: null }
    }
  } catch (e) {
    Cookie.remove('wms-token')
    localStorage.removeItem('wms-user')
    return { token: '', userInfo: null }
  }
  return { token, userInfo: safeParse(localStorage.getItem('wms-user')) }
}

const initialAuth = readInitialAuth()

export default new Vuex.Store({
  state: {
    token: initialAuth.token,
    userInfo: initialAuth.userInfo,
    branding: safeParseBranding(localStorage.getItem('wms-branding')) || { ...DEFAULT_BRANDING }
  },
  getters: {
    companyName(state) {
      return (state.branding && state.branding.companyName) || DEFAULT_BRANDING.companyName
    },
    shortName(state) {
      return (state.branding && state.branding.shortName)
        || (state.branding && state.branding.companyName)
        || DEFAULT_BRANDING.shortName
    },
    systemName(state) {
      return (state.branding && state.branding.systemName) || DEFAULT_BRANDING.systemName
    },
    /** 浏览器标题 / 打印抬头：单位名 + 系统名 */
    fullTitle(state, getters) {
      const company = getters.companyName
      const system = getters.systemName
      if (!company) return system
      if (!system || company.includes(system) || system.includes(company)) return company
      return company + system
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      Cookie.set('wms-token', token, { expires: 1 })
    },
    SET_USER(state, user) {
      state.userInfo = user || null
      localStorage.setItem('wms-user', JSON.stringify(user || null))
      // 登录用户所属单位品牌（按租户隔离，避免串单位名）
      if (user && (user.companyName || user.shortName)) {
        state.branding = {
          companyName: user.companyName || '',
          shortName: user.shortName || user.companyName || '',
          contactPhone: user.contactPhone || '',
          systemName: user.systemName || DEFAULT_BRANDING.systemName
        }
        localStorage.setItem('wms-branding', JSON.stringify(state.branding))
      }
    },
    SET_BRANDING(state, branding) {
      state.branding = branding || { ...DEFAULT_BRANDING }
      localStorage.setItem('wms-branding', JSON.stringify(state.branding))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = null
      Cookie.remove('wms-token')
      localStorage.removeItem('wms-user')
      // 退出后清掉租户品牌，登录页再拉平台品牌
      state.branding = { ...DEFAULT_BRANDING }
      localStorage.removeItem('wms-branding')
    }
  }
})
